import { useContextValue } from "../../context/context";

import "./style.css";

const SubmitButton = () => {
	const { setOrders, selectedDate, resetFormState } = useContextValue();
	const { filledCards } = useContextValue();

	const handleCreateOrder = () => {
		const newOrder = {
			id: crypto.randomUUID(),
			date: selectedDate.date,
			status: "pending",
		};

		setOrders(prev => [...prev, newOrder]);
		resetFormState();
	};

	const submitButton = filledCards.length === 9 ? "submit-button" : "submit-button disabled";
	return (
		<div>
			{
				filledCards.length !== 9 && <p className="submit-button__text">Bitte füllen Sie alle Felder aus</p>
			}
			<button className={submitButton} onClick={() => handleCreateOrder()}>Anfrage Schicken</button>
		</div>
	)
}

export default SubmitButton;
